<div class="grid grid-cols-4 items-center gap-x-1 p-2 lg:p-1.5 rounded-lg mt-2 lg:mt-1 text-gray-600 hover:bg-gray-100/80 transition-colors select-none cursor-pointer"
     [routerLinkActive]="['bg-theme-primary-50', '!text-theme-primary-700', 'font-semibold']">
  <div class="col-span-1 flex" #icon>
    <div class="m-auto h-7 w-7 lg:h-6 lg:w-6">
      <ng-content/>
    </div>
  </div>
  <div class="col-span-3 flex" #text>
    <div class="flex flex-col place-self-center -space-y-1">
      <span class="lg:text-sm">{{ title }}</span>
      <span *ngIf="subtitle != ''" class="text-gray-400 text-sm lg:text-xs">{{ subtitle }}</span>
    </div>
  </div>
</div>
